module.exports = __webpack_public_path__ + "img/test.25a2ce65.jpg";